import { DataEntity, DataEntityWithResources, DataField, DataListDataListEntityWithResources, DataListEntity, DataListField } from '@ncg/data';

export const isDataList = (field?: DataField | DataListField): field is DataListField => Array.isArray(field?.data);
export const isDataListEntity = (entity?: DataEntity | DataListEntity): entity is DataListEntity => isDataList(entity?.fields?.[0]);
export const isDataListEntityWithResources = (
    entity?: DataEntityWithResources | DataListDataListEntityWithResources
): entity is DataListDataListEntityWithResources => isDataList(entity?.fields?.[0]);
